import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowDownstreamLensesQueryVariables, FlowDownstreamLensesQuery, LensesDisplayGridRowDataFragment, FlowDownstreamLensesFilteredByFlowOutputFieldQueryVariables, FlowDownstreamLensesFilteredByFlowOutputFieldQuery, LensSortOrder , FlowDownstreamLensesFilteredByFlowOutputFieldDocument , FlowDownstreamLensesDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForLens, LensesDisplayGrid, LensesDisplayGridRowData } from '../sharedDisplayGrid/LensesDisplayGrid';
import { LensesValidSortFields } from '../sorting/sortProviders/LensesGridSortProvider';

type QueryVariables = FlowDownstreamLensesQueryVariables;
type QueryResults = FlowDownstreamLensesQuery;
type QueryResultListNode = LensesDisplayGridRowDataFragment;
type GridRowData = LensesDisplayGridRowData;

type QueryVariablesWithFilter = FlowDownstreamLensesFilteredByFlowOutputFieldQueryVariables;
type QueryResultsWithFilter = FlowDownstreamLensesFilteredByFlowOutputFieldQuery;
type QueryResultListNodeWithFilter = LensesDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  return flow ? flow.downstreamLensesConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const flow = resultData && resultData.flows && resultData.flows[0];
  const flowOutputFields = flow && flow.outputFieldsConnection && flow.outputFieldsConnection.nodes;
  const field = flowOutputFields && flowOutputFields[0];
  return field ? field.downstreamLensesConnection : null;
}

export type FlowDownstreamLensesQueryGridProps =
  GridSortProps<LensesValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredFlowOutputFieldId: string | null;
    readonly rowCount: number | null;
  };

export function FlowDownstreamLensesQueryGrid(props: FlowDownstreamLensesQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamLensesLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredLensesLineageGridMessage();

  return props.filteredFlowOutputFieldId ? (
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNodeWithFilter, GridRowData>
      queryGql={FlowDownstreamLensesFilteredByFlowOutputFieldDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedFlowOutputFieldId: props.filteredFlowOutputFieldId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => <LensesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={FlowDownstreamLensesDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as LensSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForLens}
    >
      {({ rowStore }) => <LensesDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>);
}
